export default {"src":"/_next/static/media/ARRY.aa07c008.svg","height":18,"width":18};